// @ts-nocheck

import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {ResetPassword} from './components/ResetPassword'
import {Login} from './components/Login'
import {AutoLogin} from './components/AutoLogin'
import {Yad2Register} from './components/Yad2Register'
import {AuthLayout} from './AuthLayout'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='registration-affiliate' element={<Registration />} />
      <Route path='registration-single-profile' element={<Registration type={'single-profile'}/>} />
      {/* Public affiliate-referred signup with yad2 agent picker */}
      <Route path='yad2-register' element={<Yad2Register />} />
      {/* Same signup, no yad2 agent picker / import */}
      <Route path='register' element={<Yad2Register withYad2={false} />} />
      {/* Forgot-password temporarily disabled */}
      {/* <Route path='forgot-password' element={<ForgotPassword />} /> */}
      {/* <Route path='reset-password' element={<ResetPassword />} /> */}
      <Route path='auto-login' element={<AutoLogin />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
